import { addDays, format } from 'date-fns';
import { ru } from 'date-fns/locale';

export const formatDateWithOffset = (daysToAdd: number, withYear = true): string => {
  const targetDate = addDays(new Date(), daysToAdd);
  return format(targetDate, withYear ? 'd MMMM yyyy' : 'd MMMM', { locale: ru });
};
